import './scrollTrigger';
import Flickity from 'flickity';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import _debounce from 'lodash/debounce';
import { getBreakpoint, getRTL } from './_utils';
import { initConversationCardsUnder } from './conversationCard';

window.FS = window.FS || {};
window.FS.JOURNEY_AWARENESS = window.FS.JOURNEY_AWARENESS || {};

const heroClassName = 'FullscreenHero';

const classes = {
	navHasHero: 'Navigation--hasHero',
	navAutoOpen: 'NavigationCAW--open',
	hasQuickLinks: 'has-quick-links',
	hasConversationCard: 'has-conversation-card',
};
const selectors = {
	hero: `.${heroClassName}`,
	baseHero: '.Hero',
	bgImage: '.Hero .BackgroundImage',
	heroVideo: '.Hero-video',
	container: `.${heroClassName}-container`,
	underHero: `.${heroClassName}-underHero`,
	rectangle: '.rectangle',
	innerRectangle: '.innerRectangle',
	headingContainer: `.${heroClassName}-headingContainer`,
	noAnimate: `.${heroClassName}-noAnimate`,
	AlertBanner: '.AlertBanner',
	interstitialOfferBanner: '.InterstitialOfferBanner',
	footer: '.Navigation-sticky-footer',
	nav: 'nav',
	navSm: '.Navigation-sm.is-Stick',
	wrapper: `.${heroClassName}-wrapper`,
	mobileUnderHero: `.${heroClassName}-mobileUnderHero`,
	conversationCard: `.ConversationCard`,
	navAutoOpen: `.${classes.navAutoOpen}`,
	centeredContent: `.${heroClassName}-CenteredContent`,
	heroBackgroundDesktop: '.hero-background-desktop',
	heroBackgroundTablet: '.hero-background-tablet',
};

export const moveQuickLinksFromHeroToBody = ({ ensureBodySectionTopSpacing, deleteFromHero }) => {
	const bodySection = document.querySelector('.BodySection');

	if (bodySection) {
		//move the  Quick Links from the hero to the body
		const quickLinks = document.querySelector(`${selectors.hero} .QuickLinks--body`);
		if (quickLinks) {
			bodySection.prepend(quickLinks);

			// Call resize on tablet Quick Links to set left position.
			// Otherwise all will have left position of 0px.
			$('.QuickLinks--tablet .flickity-enabled').each((index, flickityQuickLinkCarousel) => {
				const flickity = new Flickity(flickityQuickLinkCarousel);
				flickity.resize();
			});
		}

		if (deleteFromHero) {
			//move the  Quick Links from the hero to the body
			const quickLinksHeroList = document.querySelectorAll(
				`${selectors.hero} .QuickLinks--hero`
			);
			quickLinksHeroList.forEach(quickLinksHero => {
				quickLinksHero.remove();
			});
		}

		if (ensureBodySectionTopSpacing) {
			//add the top spacing back to the first BodySection
			bodySection.classList.remove('BodySection--not-first');
		}
	}
};

export const addConversationCardToHero = ({ cardHtml }) => {
	//find the fullscreen hero
	const fullscreenHero = document.querySelector(selectors.hero);

	if (fullScreenHero) {
		//remove the quick links class, if present and add the conversation card text
		fullscreenHero.classList.remove(classes.hasQuickLinks);
		fullscreenHero.classList.add(classes.hasConversationCard);

		const fullScreenHeroBackgroundDesktop = fullscreenHero.querySelector(
			selectors.heroBackgroundDesktop
		);
		const fullScreenHeroBackgroundTablet = fullscreenHero.querySelector(
			selectors.heroBackgroundTablet
		);

		// Add to Desktop and Tablet
		const fullScreenHeroTextDesktop = fullScreenHeroBackgroundDesktop.querySelector(
			selectors.headingContainer
		);
		fullScreenHeroTextDesktop.insertAdjacentHTML('afterend', cardHtml);
		const fullScreenHeroTextTablet = fullScreenHeroBackgroundTablet.querySelector(
			selectors.headingContainer
		);
		fullScreenHeroTextTablet.insertAdjacentHTML('afterend', cardHtml);

		//need to add the mobile version too
		const underHero = document.querySelector(selectors.mobileUnderHero);
		if (underHero) {
			underHero.insertAdjacentHTML('beforeend', cardHtml);
		}

		initConversationCardsUnder(selectors.hero);
		setupConversationCard();
	}
	return fullscreenHero;
};

export const setHeroComponentAnimationDirection = direction => {
	//find the fullscreen hero
	const fullscreenHeroContainerList = document.querySelectorAll(selectors.container);
	fullscreenHeroContainerList.forEach(fullscreenHeroContainer => {
		fullscreenHeroContainer.dataset.animationdir = direction;
	});
};

window.FS.JOURNEY_AWARENESS.moveQuickLinksFromHeroToBody = moveQuickLinksFromHeroToBody;
window.dispatchEvent(new Event('fsActionReady'));
const setupConversationCard = () => {
	const $mobileConversationCard = $(`${selectors.mobileUnderHero} ${selectors.conversationCard}`);
	const $headingContainer = $(selectors.headingContainer);
	$(selectors.mobileUnderHero).prepend($mobileConversationCard);

	const positionCard = () => {
		const isSmall = getBreakpoint().includes('small');
		if (isSmall && $mobileConversationCard.length) {
			const isCenteredContent = $(selectors.centeredContent).length > 0;
			const conversationCardHeight = $mobileConversationCard.outerHeight();
			const top = isCenteredContent ? -(conversationCardHeight - 30) : -81; //centered 348px in, otherwise 51px in and overcoming the margin of 30
			const paddingBottom = isCenteredContent ? 180 : 71; //centered 180px, otherwise 51px of the conversation card and padding 20 between container and card
			$mobileConversationCard.css({
				position: 'relative',
				top: top,
				'margin-bottom': top + 30,
				opacity: 1,
			});
			$headingContainer.css({ 'padding-bottom': paddingBottom });
		} else {
			$headingContainer.css({ 'padding-bottom': '' });
		}
	};
	positionCard();
	$(window).on('resize', _debounce(positionCard, 100));
};

export default function fullScreenHero() {
	setupConversationCard();
	const wrappers = [];
	let alertReady = false;
	const timelines = [];
	const resume = () => {
		timelines.forEach(tl => {
			if (tl && tl.paused()) {
				if (alertReady) {
					tl.to(
						wrappers,
						{
							duration: 1,
							height: getBreakpoint().includes('large')
								? getLoadedHeroHeight(0.9)
								: '',
						},
						'start'
					);
				}
				tl.resume();
			}
		});
	};
	const getLoadedHeroHeight = percent => {
		const banner = document.querySelector(selectors.AlertBanner);
		const bannerHeight = banner ? banner.offsetHeight : 0;
		const interstitialOfferBanner = document.querySelector(selectors.interstitialOfferBanner);
		const interstitialOfferBannerHeight = interstitialOfferBanner
			? interstitialOfferBanner.offsetHeight
			: 0;
		const footer = document.querySelector(selectors.footer);
		const footerHeight = footer ? footer.offsetHeight : 0;
		const navSm = document.querySelector(selectors.navSm);
		const navSmHeight = navSm ? navSm.offsetHeight : 0;
		const nav = document.querySelector(selectors.nav);
		const navHeight = nav && !nav.classList.contains(classes.navHasHero) ? nav.offsetHeight : 0;
		const height =
			window.innerHeight * percent -
			bannerHeight -
			interstitialOfferBannerHeight -
			footerHeight -
			navSmHeight -
			navHeight;
		return height;
	};

	const alertEventHandler = e => {
		alertReady = true;
		resume();
	};
	$(document).on('alertBannerAdded', alertEventHandler);
	$(document).on('noAlertBanner', alertEventHandler);

	ScrollTrigger.saveStyles(
		`${selectors.hero}, ${selectors.container}, ${selectors.baseHero}, ${selectors.heroVideo}, ${selectors.bgImage}`
	);
	ScrollTrigger.matchMedia({
		// large
		'(min-width: 961px)': function () {
			document.querySelectorAll(selectors.hero).forEach((hero, heroIndex) => {
				//don't auto open the CAW when there is a fullscreen hero
				const navCAWAutoOpening = document.querySelector(selectors.navAutoOpen);
				if (navCAWAutoOpening) {
					navCAWAutoOpening.classList.remove(classes.navAutoOpen);
				}
				const baseHero = hero.querySelector(selectors.baseHero);
				const heroVideo = hero.querySelector(selectors.heroVideo);
				const bgImage = hero.querySelector(selectors.bgImage);
				const container = hero.querySelector(selectors.container);
				const wrapperElements = hero.querySelectorAll(selectors.wrapper);
				wrappers.push([baseHero, heroVideo, bgImage, container, ...wrapperElements]);

				const initHeroComponents = () => {
					const components = container.querySelectorAll(
						`:scope > div:not(${selectors.rectangle}):not(${selectors.headingContainer}):not(${selectors.noAnimate})`
					);
					const direction = container.attributes['data-animationdir']
						? container.attributes['data-animationdir'].value
						: 'right';
					const componentsContainerTo = { duration: 0.8, opacity: 1, delay: 0.4 };
					const componentsContainerExitTo = { duration: 1, opacity: 0 };
					if (direction === 'bottom') {
						componentsContainerTo.translateY = '0%';
						componentsContainerExitTo.translateY = '100%';
					} else {
						componentsContainerTo.translateX = '0%';
						componentsContainerExitTo.translateX = `${getRTL() ? '-' : ''}150px`;
					}
					const tlScroll = gsap.timeline({
						id: `scrollTl-${heroIndex}`,
						scrollTrigger: {
							trigger: document.querySelector('body'),
							start: 'top top',
							end: '+=100',
							scrub: 1,
							invalidateOnRefresh: true,
							onEnter: () => {
								gsap.to(hero.querySelector(selectors.underHero), {
									opacity: 0,
									height: 0,
									paddingTop: 0,
									duration: 2,
									onComplete: ScrollTrigger.refresh,
								});
							},
						},
					});
					tlScroll.addLabel('start');
					tlScroll.to(components, componentsContainerExitTo, 'start');
					tlScroll.addLabel('end');
					const tl = gsap.timeline({
						id: `hero-${heroIndex}`,
						onComplete: () => {
							$(wrappers).addClass('loaded');
							tlScroll.scrollTrigger.refresh();
						},
						paused: true,
					});
					if (direction === 'bottom') {
						tl.set(components, { translateX: '0%', zIndex: 2 });
					} else {
						tl.set(components, { translateY: '0%', zIndex: 2 });
					}
					timelines.push(tl);
					tl.addLabel('start')
						.to(components, componentsContainerTo, 'start')
						.addLabel('loaded')
						.to(
							[
								hero.querySelector(selectors.rectangle),
								hero.querySelector(selectors.underHero),
							],
							{ duration: 2, opacity: 1 },
							'loaded'
						)
						.from(
							hero.querySelector(selectors.underHero),
							{ duration: 2, paddingTop: 10 },
							'loaded'
						)
						.addLabel('fadedIn')
						.to(hero.querySelector(selectors.innerRectangle), {
							duration: 2,
							bottom: '-100%',
							repeat: -1,
							repeatDelay: 2,
						})
						.addLabel('end');

					document.addEventListener('scroll', function (e) {
						gsap.to([hero.querySelector(selectors.rectangle)], {
							duration: 1,
							opacity: 0,
						});
					});
					//Once page is loaded (or after 1s) - animates into “Loaded” state
					if (scrollY !== 0) {
						gsap.set([hero.querySelector(selectors.rectangle)], { opacity: 0 });
						tl.seek('end');
						resume();
					} else if (alertReady) {
						resume();
					}
					setTimeout(() => {
						resume();
					}, 1000);
				};

				if (container.dataset['delayComponentAnimation']) {
					$(window).on('beginHeroComponentAnimation', initHeroComponents);
				} else {
					initHeroComponents();
				}
			});
		},
	});
}
